module.exports = __webpack_public_path__ + "img/jabka_250ml.cc955fa5.png";